var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAttachments = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#attachments_svg__a)",
  stroke: "#6D727F",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.615 1h-6.23C1.62 1 1 1.62 1 2.385v6.23C1 9.38 1.62 10 2.385 10h6.23C9.38 10 10 9.38 10 8.615v-6.23C10 1.62 9.38 1 8.615 1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.692 3h.77A1.538 1.538 0 0 1 13 4.538v6.923A1.538 1.538 0 0 1 11.461 13H4.538A1.539 1.539 0 0 1 3 11.461v-.769"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "attachments_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export default SvgAttachments;